export default "__VITE_ASSET__B5r91Rm1__"